import * as organizationActions from "./constants";

export const SetOrganizationData = (data) => {
  return {
    type: organizationActions.SET_ORGANIZATION_INFO,
    payload: data,
  };
};
